import { TemplateDto } from "@exibra/shared";
import { cn } from "@/lib/utils";
import { getTemplateOrientation, getTemplateThumbColors } from "../template-meta";

const SHAPE: Record<string, string> = {
    horizontal: "h-[22px] w-9",
    vertical: "h-9 w-[22px]",
    responsive: "h-[22px] w-9",
};

/**
 * Lightweight, render-cheap template thumbnail for the list view. Conveys the template's canvas
 * background, its LED accent (as a glowing base strip), and its orientation through the tile shape —
 * without spinning up a Konva stage per row. The rich Konva preview is reserved for the gallery view.
 */
export function TemplateThumb({ template }: { template: TemplateDto }) {
    const orientation = getTemplateOrientation(template);
    const { background, accent } = getTemplateThumbColors(template);

    return (
        <span className="flex size-9 flex-none items-center justify-center">
            <span
                className={cn(
                    "relative overflow-hidden rounded-[3px] border border-border/70",
                    SHAPE[orientation],
                    !background && "bg-muted",
                )}
                style={background ? { backgroundColor: background } : undefined}
            >
                <span
                    className="absolute inset-x-0 bottom-0 h-[3px]"
                    style={{ backgroundColor: accent }}
                />
                {orientation === "responsive" && (
                    <span className="absolute bottom-[3px] right-0.5 h-2.5 w-1.5 rounded-[1px] border border-border/70 bg-background/70" />
                )}
            </span>
        </span>
    );
}
